import React, { Component } from 'react'
import Store from './store'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'
import {
  isWeddingDressProperty,
  isWeddingEmceeProperty,
  isWeddingPlanProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { getMerchantInfo, isStoreAccount, isSiYiTeam } from '@util'

import {
  Button,
  DatePicker,
  InputNumber,
  MagicInput,
  Radio,
  Select,
  Switch
} from 'hljd'
import { toJS } from 'mobx'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'
import { COUPONS_PATH } from '@constant'
import ChooseModal from './ChooseModal'
import PackageList from './PackageList'
import {
  COLLECTION_STORE,
  ONLY_MEMBER
} from '@components/LocalMerchant/Coupons/constant'

const Item = Form.Item
const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const RangePicker = DatePicker.RangePicker
const Option = Select.Option

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      routeParams: { id },
      location: { query }
    } = this.props

    this.store = new Store(id, query)
  }

  componentDidMount() {
    this.store.getProperties()
    this.store.getList()
  }

  render() {
    const store = this.store
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    }
    const radioStyle = {
      display: 'block',
      height: '46px',
      lineHeight: '46px'
    }
    const {
      coupon_type,
      property_id,
      is_limit,
      condition_of_get,
      value,
      type,
      money_sill,
      provide,
      valid,
      total_count,
      title,
      hidden,
      isEdit,
      id,
      hiddenDisabled,
      propertiesList,
      scope,
      openChooseModal
    } = store
    const header = [
      <Link to={COUPONS_PATH}>优惠券 </Link>,
      `${id ? '编辑' : '创建'}优惠券`
    ]

    return (
      <HeaderView header={header} title={`${id ? '编辑' : '创建'}优惠券`}>
        <div style={{ marginTop: 30 }}>
          <Form layout="horizontal">
            <Item>
              <RadioGroup
                style={{ marginLeft: '11%', display: 'block' }}
                value={coupon_type}
                onChange={store.changeField('coupon_type')}
                disabled={isEdit}
              >
                <RadioButton value="1">普通优惠券</RadioButton>
                <RadioButton value="2">特殊专享券</RadioButton>
              </RadioGroup>

              <div className={styles.tipBox}>
                <ExclamationCircleFilled style={{ marginRight: 8 }} />
                {coupon_type == '1' &&
                  '普通优惠券 主要用来促进套餐的整体售卖，线上所有用户都能领取使用。'}
                {coupon_type == '2' &&
                  '特殊专享券 为非公开领取的优惠券，只有商家主动通过私信、直播等渠道发放给用户时可领取。通过对意向强烈用户发放专属优惠，击破新人最后的价格心理防线。'}
              </div>
            </Item>

            <Item label="优惠券备注" {...layout} required>
              <MagicInput
                showCount
                style={{ width: 363 }}
                countPosition="right"
                value={title}
                maxLength={20}
                onChange={e => store.changeField('title')(e)}
              />
              <p>优惠券名称仅用于商家后台，不显示在婚礼纪APP中</p>
            </Item>

            <Item label="金额" {...layout} required>
              <InputNumber
                placeholder="正整数"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                precision={0}
                min={1}
                value={value}
                onChange={store.changeField('value')}
                style={{ width: 260 }}
                disabled={isEdit}
              />
              <span style={{ paddingLeft: 10 }}>
                元<i style={{ color: '#999' }}>（保存后不可更改）</i>
              </span>
            </Item>

            {!isWeddingEmceeProperty() &&
              coupon_type == '1' && (
                <Item label="使用范围" {...layout} required>
                  <RadioGroup
                    value={scope + ''}
                    onChange={store.changeScope}
                    disabled={isEdit}
                  >
                    <Radio style={radioStyle} value={'1'}>
                      全场可用
                    </Radio>
                    {!isStoreAccount() && (
                      <Radio
                        style={radioStyle}
                        value={'2'}
                        onClick={openChooseModal}
                      >
                        指定套餐可用（保存后不可更改）
                      </Radio>
                    )}
                  </RadioGroup>
                </Item>
              )}

            <PackageList store={this.store} />

            <Item label="使用条件" {...layout} required>
              <RadioGroup
                value={type + ''}
                onChange={store.changeField('type')}
                disabled={scope == '2' || isEdit}
              >
                <Radio style={radioStyle} value={'1'}>
                  满减券：满
                  <InputNumber
                    placeholder="正整数"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    precision={0}
                    min={0}
                    value={money_sill}
                    onChange={store.changeField('money_sill')}
                    style={{ width: 260, margin: '0 10px' }}
                    disabled={scope == '2' || isEdit}
                  />
                  元使用
                </Radio>
                <Radio style={radioStyle} value={'2'}>
                  无门槛：无使用金额限制（保存后不可更改）
                </Radio>
              </RadioGroup>
            </Item>

            {getMerchantInfo().is_franchisee == '1' && (
              <Item label="限制类目" {...layout} required>
                <Switch
                  checked={is_limit}
                  onChange={store.changeValue('is_limit')}
                  checkedChildren="限制"
                  unCheckedChildren="不限"
                  disabled={isEdit}
                />

                <span style={{ color: '#999', paddingLeft: 8 }}>
                  (保存后不可修改)
                </span>

                <div>
                  <span>仅限选中类目的套餐可用(可多选)</span>
                  <Select
                    mode="multiple"
                    style={{ width: 220, marginLeft: 8 }}
                    disabled={isEdit || !is_limit}
                    value={toJS(property_id)}
                    placeholder={'请选择'}
                    onChange={store.changeValue('property_id')}
                  >
                    {propertiesList.map(({ id, name }) => (
                      <Option value={id} key={id}>
                        {name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Item>
            )}

            {coupon_type == '1' &&
              !isWeddingDressProperty() &&
              !isWeddingPlanProperty() &&
              !isWeddingRingJewelryProperty() &&
              !isSiYiTeam() && (
                <Item label="领取条件" {...layout} required>
                  <RadioGroup
                    value={condition_of_get + ''}
                    onChange={store.changeCondition_of_get}
                  >
                    <Radio style={radioStyle} value={'0'}>
                      无
                    </Radio>
                    <Radio style={radioStyle} value={COLLECTION_STORE}>
                      加入收藏可领取
                    </Radio>
                    <Radio style={radioStyle} value={ONLY_MEMBER}>
                      仅会员可领取
                    </Radio>
                  </RadioGroup>
                </Item>
              )}

            <Item label="领取时间" {...layout} required>
              <RangePicker
                value={toJS(provide)}
                onChange={store.changeField('provide')}
              />
            </Item>

            <Item label="有效期" {...layout} required>
              <RangePicker
                value={toJS(valid)}
                onChange={store.changeField('valid')}
                disabled={isEdit}
              />
              <p style={{ color: '#aaa' }}>
                有效期开始之前用户可以领取但不能使用，保存后不可更改
              </p>
            </Item>

            <Item label="发行量" {...layout} required>
              <InputNumber
                placeholder="正整数，需小于100,000"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                max={100000}
                min={0}
                precision={0}
                value={total_count}
                onChange={store.changeField('total_count')}
                style={{ width: 260 }}
              />
              <span style={{ paddingLeft: 10 }}>张</span>
              <p>保存后修改发行量时只能增加不能减少</p>
            </Item>

            <Item label="激活状态" {...layout} required>
              <RadioGroup
                value={hidden + ''}
                onChange={store.changeField('hidden')}
                disabled={hiddenDisabled}
              >
                <Radio value={'1'}>激活</Radio>
                <Radio value={'0'}>不激活</Radio>
              </RadioGroup>
            </Item>
          </Form>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={store.editCoupon}>
            保存
          </Button>
          <Button style={{ marginLeft: 20 }} onClick={store.cancel}>
            取消
          </Button>
        </div>
        <ChooseModal
          type="meal"
          title="选择套餐"
          price={true}
          store={this.store}
        />
      </HeaderView>
    )
  }
}
